import React, {Fragment} from "react";
import {Grid, TextField, MenuItem, Typography, Button, useTheme} from "@material-ui/core";
import Rest from "../../../helpers/Rest";
import ProgressOr from "../../../components/ProgressOr";
import {useCustomers} from "../../../context/CustomersContext";
import DeviceHealth from "../charts/DeviceHealth";
import {statuses, columnOffsets} from "../Config"
import DevicesInUse from "../charts/DevicesInUse";
import EventsOverview from "../charts/EventsOverview";
import {Add} from "@material-ui/icons";
import useStyles from "./styles"
import {useDevices} from "../../../context/DevicesContext";
import {useParams} from "react-router-dom"
import DeviceTable from "../DeviceTable";

const statusMap = {
    faulty: 0,
    warning: 1,
    inactive: 2,
    healthy: 3,
    uninstalled: 4
}

const statusProps = [
    statuses.faulty.label, statuses.faulty.colour,
    statuses.warning.label, statuses.warning.colour,
    statuses.inactive.label, statuses.inactive.colour,
    statuses.healthy.label, statuses.healthy.colour,
    statuses.uninstalled.label, statuses.uninstalled.colour
]

const {
    ID, CUSTOMER, SITE, STATUS, VEHICLE
} = columnOffsets;

const STORAGE_KEY = 'DEVICE_FILTERS'

function bloatForEventsOverview(data){
    for (const key in data){
        data[key] = data[key].map(item => {
            return {value: item}
        })
    }
    return data
}

function getSavedFilters(){
    const stored = window.localStorage.getItem(STORAGE_KEY)
    if (stored){
        return JSON.parse(stored)
    }
    return {
        customer: null,
        site: null
    }
}

Rest.addLogoutListener(() => window.localStorage.removeItem(STORAGE_KEY))

class DeviceList extends React.Component{
    static EDIT_PATH = 'edit-device'
    static SERVICE_PATH = 'device'
    /*static MISSING_CUSTOMER = {
        name: 'None',
        sites: []
    }
    static MISSING_SITE = {
        name: 'None'
    }*/

    constructor(props){
        super(props)
        this.state = {
            ...getSavedFilters(),
            customers: null,
            eventsOverview: null,
            devicesInUse: null,
            devices: null
        }
    }

    getChartUrl(type, site, customer){
        const url = `report/${type}/30`
        if (site){
            return `${url}?site=${site}`
        }
        if (customer){
            return `${url}?customer=${customer}`
        }
        return url
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.vehicleId !== prevProps.vehicleId){
            this.setState({
                devices: this.filterForVehicle(this.state.raw)
            })
        }
    }

    componentDidMount() {
        this.fetchData()
    }

    componentWillUnmount() {
        if (!Rest.getUser()){
            return;
        }
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
            customer: this.state.customer,
            site: this.state.site
        }))
    }

    refreshCharts(site, customer){
        Rest.get(this.getChartUrl("events_by_day", site, customer)).then(reply => {
            this.setState({
                eventsOverview: bloatForEventsOverview(reply)
            })
        })
        Rest.get(this.getChartUrl("devices_by_day", site, customer)).then(reply => {
            this.setState({
                devicesInUse: reply
            })
        })
    }

    filterForVehicle(devices){
        const {vehicleId} = this.props
        if (vehicleId){
            const map = {}
            return {
                list: devices.list.filter(row => {
                    if (row[VEHICLE] === vehicleId){
                        map[row[ID]] = row
                        return true
                    }
                    return false
                }),
                map: map
            }
        }
        return devices
    }

    fetchData(){
        this.props.customersContext.fetchCustomers().then(customers => this.setState({
            customers: customers
        }))
        this.props.devicesContext.fetchDevices().then(devices => this.setState({
            raw: devices,
            devices: this.filterForVehicle(devices)
        }))
        this.refreshCharts(this.state.site, this.state.customer)
    }

    async delete(devices) {
        await Promise.all(devices.map((device) => Rest.del(`${DeviceList.SERVICE_PATH}/${device[ID]}`)))
        if (this.props.onDeleted){
            this.props.onDeleted(devices)
        }
    }

    getSites(){
        if (!this.state.customer){
            return []
        }
        return this.state.customers.map[this.state.customer].sites || []
    }

    applyFilters() {
        const {site, customer, customers, devices} = this.state
        if (!devices){
            return null
        }
        if (site){
            return devices.list.filter(row => row[SITE] === site)
        }
        if (customer) {
            return customers ? devices.list.filter(row => row[CUSTOMER] === customer) : null
        }
        return devices.list
    }

    setSite(e){
        const site = e.target.value
        this.setState({
            site: site
        })
        this.refreshCharts(site, this.state.customer)
    }

    setCustomer(e){
        const customer = e.target.value
        this.setState({
            customer: customer,
            site: null
        })
        this.refreshCharts(null, customer)
    }

    getDeviceHealthData(devices){
        const len = statusProps.length >> 1
        const totals = new Array(len)
        for (let i = 0; i < len; totals[i++] = 0);
        devices.forEach(device => {
            ++totals[statusMap[device[STATUS]]]
        })
        return totals.map((total, idx) => {
            idx <<= 1
            return {
                name: statusProps[idx],
                color: statusProps[idx + 1],
                value: total
            }
        }).filter(item => item.value > 0).sort((a, b) => b.value - a.value)
    }

    eventsOverview(){
        const {eventsOverview} = this.state
        return (
            <ProgressOr showProgress={!eventsOverview} progressMessage="Fetching events...">
                {eventsOverview ? <EventsOverview
                    warnings={eventsOverview.warning}
                    vovs={eventsOverview.vov}
                    stops={eventsOverview.stop}
                    panics={eventsOverview.panic}
                    disables={eventsOverview.disable}
                /> : ""}
            </ProgressOr>
        )
    }

    devicesInUse(){
        const {devicesInUse} = this.state
        return (
            <ProgressOr showProgress={!devicesInUse} progressMessage="Fetching events...">
                {devicesInUse ? <DevicesInUse data={devicesInUse}/> : ""}
            </ProgressOr>
        )
    }

    getCharts(devices){
        if (!devices){
            return ''
        }
        return (
            <Fragment>
                <Grid item xs={12} sm={6} lg={3}>
                    <DeviceHealth data={this.getDeviceHealthData(devices)}/>
                </Grid>
                {this.props.vehicleId ? null : <>
                    <Grid item xs={12} sm={6} lg={3}>
                        {this.eventsOverview()}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        {this.devicesInUse()}
                    </Grid>
                </>}
            </Fragment>
        )
    }

    customers(){
        const {devices, customer, customers} = this.state
        return customers.list && customers.list.length ? (
            <TextField label="Customer"
                   onChange={this.setCustomer.bind(this)}
                   value={customer || 0}
                   disabled={!devices}
                   variant="outlined"
                   style={{margin:"8px 16px 8px 0"}}
                   size="small"
                   select
            >
                <MenuItem key={0} value={0}>All Customers</MenuItem>
                {customers.list.map(customer => {
                    return (
                        <MenuItem key={customer.id} value={customer.id}>{customer.name}</MenuItem>
                    )
                })}
            </TextField>
        ) : "";
    }

    sites(){
        return (
            <TextField label="Site"
                       onChange={this.setSite.bind(this)}
                       value={this.state.site || 0}
                       disabled={!this.state.customer}
                       variant="outlined"
                       style={{margin:"8px 16px 8px 0"}}
                       size="small"
                       select
            >
                <MenuItem key={0} value={0}>All Sites</MenuItem>
                {this.getSites().map(site => {
                    return (
                        <MenuItem key={site.id} value={site.id}>{site.name}</MenuItem>
                    )
                })}
            </TextField>
        )
    }

    button(){
        return Rest.isAdmin ? (
            <Button variant="contained"
                    color="primary"
                    onClick={() => this.props.history.push(DeviceList.EDIT_PATH)}
                    startIcon={<Add/>}>
                New
            </Button>
        ) : null
    }

    headingWithVehicle(){
        return <Grid item xs={12}>
            <Typography variant="h1">Devices attached to {this.props.vehicleId}</Typography>
        </Grid>
    }

    headingWithoutVehicle(){
        return <Grid item container xs={12} className={this.props.classes.heading}>
            <Typography variant="h1" style={{flexShrink:1}}>Devices</Typography>
            <div>
                {this.customers()}
                {this.sites()}
                {this.button()}
            </div>
        </Grid>
    }

    heading(){
        return this.props.vehicleId ? this.headingWithVehicle() : this.headingWithoutVehicle()
    }

    showContent(devices){
        return (
            <Fragment>
                {this.heading(devices)}
                {this.getCharts(devices)}
                <Grid item xs={12}>
                    <DeviceTable
                        customers={this.state.customers}
                        devices={devices}
                        onEdit={(device) => {
                            console.log(device[ID])
                            this.props.history.push({
                                pathname: `${DeviceList.EDIT_PATH}/${device[ID]}`,
                                state: device
                            })
                        }}
                        onDelete={this.delete.bind(this)}
                    />
                </Grid>
            </Fragment>
        )
    }

    render(){
        const devices = this.applyFilters()
        const loading = !(devices && this.state.customers)
        return (
            <Grid container spacing={3}>
                <ProgressOr showProgress={loading} progressMessage="Fetching device list...">
                    {loading ? "" : this.showContent(devices)}
                </ProgressOr>
            </Grid>
        )
    }
}

export default (props) => {
    const classes = useStyles(useTheme())
    const {vehicleId} = useParams()
    const devices = useDevices()
    const customers = useCustomers()
    return <DeviceList
        customersContext={customers}
        devicesContext={devices}
        classes={classes}
        vehicleId={vehicleId}
        {...props}
    />
}
